<template>
  <div class="popup-toast-wrap" :class="message.type">
    <article>
      <div class="content" @click="closePopup">

        <span class="icon icon-check2" v-if="message.type === 'success'"></span>
        <span class="icon icon-times2" v-if="message.type === 'fail'"></span>
        <span class="icon icon-question-circle" v-if="message.type === ''"></span>

        <p>{{ message.message }}</p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    message: Object
  },

  mounted () {
    setTimeout(() => {
      this.closePopup()
    }, 5000)
  },

  methods: {
    closePopup () {
      this.$store.commit('setToastMessage', {
        open: false,
        type: '',
        message: ''
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.popup-toast-wrap {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 99;

  width: 100%;
  max-width: 335px;

  article {
    width: 100%;
    margin: auto;
    padding: 35px 20px;

    cursor: pointer;

    background: grey;
    border-radius: 3px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);


    .content {
      display: flex;
      align-items: center;
      width: 100%;

      font-size: 0;

      .icon {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin: 0 11px 0 0;

        font-size: 14px;
        font-weight: 700;
        line-height: 34px;
        text-align: center;
        color: grey;

        background: white;
        border-radius: 50%;
      }

      p {
        display: inline-block;
        width: calc(100% - 45px);
        margin: 0;
        padding: 6px 0;

        font-size: 14px;
        line-height: 22px;
        color: white;
      }
    }
  }
}

.popup-message-wrap.success {
  article {
    background: #38B449;
    .content .icon { color: #38B449; }
  }
}

.popup-message-wrap.fail {
  article {
    background: red;
    .content .icon { color: red; }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Toast.vue